import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import flow from 'lodash/flow';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import isToday from 'date-fns/is_today';
import {
    COMPONENT_CLASS,
    SPECIALS_LIST,
    SPECIALS_TITLE,
    SPECIALS_TITLE_ICON_CLASS_NAME,
    SPECIALS__SELECTION_TXT_CLASS_NAME,
    SPECIALS__EVENT_TXT_CLASS_NAME,
    SPECIALS__COUNTDOWN_TXT_CLASS_NAME,
    SPECIALS__OLD_PRICE_LABEL_CLASS_NAME,
    SPECIALS__OLD_PRICE_VALUE_CLASS_NAME,
    SPECIALS__OLD_PRICE_CONTAINER_CLASS_NAME,
    SPECIALS__ENHANCED_FROM_LABEL,
    SPECIALS__ENDS_IN_LABEL,
    POST_URL,
    GTM_SUB_COMPONENT,
    GTM_ACTION_SEE_ALL,
    GTM_MAIN_COMPONENT,
    GTM_SPECIAL,
    SPECIALS__WIDGET_CAROUSEL_NAV_PREV,
    SPECIALS__WIDGET_CAROUSEL_NAV_NEXT,
    SPECIALS_INSTRUCTION_CARD,
    INSTRUCTION_CONTENT_MOBILE,
    INSTRUCTION_CONTENT_WEB,
    INSTRUCTION_FOOTER_TEXT,
    ZERO,
    GTM_ACTION_SWIPE,
    SPECIALS_SWIPER_DISMISS_GTM,
} from '../constants';
import {
    mapStateToProps,
    mapDispatchToProps,
} from '../../CommonDataListEvents/utils/utils.js';
import WidgetContainer from '~shared/ui/WidgetContainer';
import i18n from '~shared/utils/i18n';
import BetCard from '../../BetCard';
import { getIsMobileWrapperFlag } from '~shared/utils/user';
import isEmpty from 'lodash/isEmpty';
import { seoUrlSport } from '~spa/Utils/SeoUrls';
import { SPECIAL_SLUG, getSportIdBySlug } from '~shared/utils/sportsbook';
import CountDownTimer from '../../CountDownTimer';
import { showWidget } from '~shared/utils/widgets';
import Carousel from '~shared/ui/Carousel';
import { withLazyLoadContext } from '~spa/Components/LazyLoad/LazyLoad';
import { getOddsFromSelection, calculateAmericanPrice } from '~shared/components/sport-event/utils';
import InstructionCard from '~shared/components/instruction-card/InstructionCard';
import { getInstructionCards } from '~shared/utils/user';
import { Trans } from 'react-i18next';
import {
    getLanguageIso,
} from '~shared/utils/user';
import { slugifyUrlEntities } from '~spa/Utils/SeoUrls';

let locales = {
        eng: require('date-fns/locale/en'),
        deu: require('date-fns/locale/de'),
        rus: require('date-fns/locale/ru'),
        spa: require('date-fns/locale/es'),
        fra: require('date-fns/locale/fr'),
        swe: require('date-fns/locale/sv'),
        fin: require('date-fns/locale/fi'),
        por: require('date-fns/locale/pt'),
    };
export class SpecialsWidgetContainer extends React.Component {
    constructor() {
        super();

        this.getDescriptionTemplate = this.getDescriptionTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.passSwiperRef = this.passSwiperRef.bind(this);
        this.setInstructionCardDismissed = this.setInstructionCardDismissed.bind(this);
        this.state = {
            swiper: null,
            instructionCardDismiss: false,
        };
    }

    static propTypes = {
        events: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array,
        ]),
        getWidgetEvents: PropTypes.func,
        commonDataEvents: PropTypes.object,
        updateCommonStoreWsData: PropTypes.func,
        source: PropTypes.string,
        isWidget: PropTypes.bool,
        lazyLoadHasLoaded: PropTypes.func,
        isLoggedIn: PropTypes.bool,
    };

    static defaultProps = {
        events: {},
        getWidgetEvents: () => null,
        commonDataEvents: {},
        updateCommonStoreWsData: () => null,
        source: '',
        isWidget: true,
        lazyLoadHasLoaded: () => null,
        isLoggedIn: false,
    };

    /**
     * Create the template for the betcard description
     * @param {Object} event The object with event data
     * @return {Element} Div element for the description
     */
    getDescriptionTemplate(event) {
        // countdown or days left to end the game
        const scheduledTime = new Date(event.start_time);
        let countdown = '';
        if (isToday(scheduledTime)) {
            countdown = <CountDownTimer
                renderCleanTimer={true}
                showFullDayCountdown={true}
                scheduledTime={event.start_time}
            />;
        } else {
            countdown = distanceInWordsToNow(scheduledTime, { locale: locales[getLanguageIso()]});
        }

        return(
            <div>
                <span className={SPECIALS__SELECTION_TXT_CLASS_NAME}>
                    {event.selection_name}
                </span>
                <span className={SPECIALS__EVENT_TXT_CLASS_NAME}>
                    {event.event_name}
                </span>
                <span className={SPECIALS__COUNTDOWN_TXT_CLASS_NAME}>
                    <div>{i18n.t(SPECIALS__ENDS_IN_LABEL)} {countdown}</div>
                </span>
            </div>
        );
    }

    /**
     * Create the template for the betcard footer
     * @param {Object} event The object with event data
     * @return {Element} Div element for the footer
     */
    getFooterTemplate(event) {

        return(
            <div className={SPECIALS__OLD_PRICE_CONTAINER_CLASS_NAME}>
                <span className={SPECIALS__OLD_PRICE_LABEL_CLASS_NAME}>
                    {i18n.t(SPECIALS__ENHANCED_FROM_LABEL)}
                </span>
                <span className={SPECIALS__OLD_PRICE_VALUE_CLASS_NAME}>
                    {event.old_price}
                </span>
            </div>
        );
    }

    /**
    * After init DOM component, load page data
    * @returns {void}
    */
    componentDidMount() {
        this.refreshBets();
    }

    async refreshBets() {
        const {
            updateCommonStoreWsData,
        } = this.props;
        /**
         * @todo https://dedsert.atlassian.net/browse/AM-2035 - change to a GET request
         */
        const postParams = {};
        await this.props.getWidgetEvents(updateCommonStoreWsData, `${POST_URL}`, postParams);
        this.props.lazyLoadHasLoaded();
    }

    /**
    * Create a list of events in the specified group
    * @param {Object} events The object with events data
    * @return {BetCard} List of Betcards
    */
    createEventsListSection(events) {
        // common events info
        const commonEvents = this.props.commonDataEvents;
        // match state event ids with commonData event ids
        const commonEventsKeys = Object.keys(commonEvents);
        // widget events
        const widgetEvents = events.filter((event) => {

            return commonEventsKeys.includes(String(event.event_id));
        });

        return (
            <>
                {widgetEvents.map((event, key) => {
                    const {
                        name,
                        start_time,
                        betable,
                    } = commonEvents[event.event_id];
                    const [market] = Object.values(commonEvents[event.event_id].markets);
                    const selections = Object.values(market.selections);
                    const [selection] = selections;
                    const betableCard = betable && market.betable;
                    const isHomePage = this.props.source === GTM_MAIN_COMPONENT;
                    const widgetName = isHomePage ? GTM_MAIN_COMPONENT : GTM_SPECIAL;
                    const subComponent = isHomePage ? GTM_SUB_COMPONENT : commonEvents[event.event_id].category_name;

                    const gtm = `${widgetName};${subComponent};`;

                    return (
                        <BetCard
                            key={key}
                            selections={selections}
                            description={this.getDescriptionTemplate({
                                selection_name: selection.name,
                                event_name: name,
                                start_time,
                            })}
                            betable={betableCard}
                            betCardFooterElement={this.getFooterTemplate({
                                old_price: selection.old_decimal_price
                                    ? getOddsFromSelection({
                                        ...selection,
                                        american_price: calculateAmericanPrice(selection.old_decimal_price),
                                        fraction_price: selection.old_fraction_price,
                                        decimal_price: selection.old_decimal_price,
                                    })
                                    : null,
                            })}
                            gtmAttribute={gtm}
                        >
                        </BetCard>
                    );
                })}
            </>
        );
    }

    getSliderArrows(cName) {
        if (getIsMobileWrapperFlag()) {
            return null;
        }

        return React.createElement('div', {className: cName});
    }

    /*
     * used to pass swiper element up from carousel
     * so that it can be passed to instruction card
     */
    passSwiperRef(ref) {
        this.setState({
            swiperRef: ref.current,
        });
    }

    setInstructionCardDismissed() {
        this.setState({
            instructionCardDismiss: true,
        });
    }

    /**
    * Render the component
    * @returns {JSX.Element} Returns a React Element
    */
    render() {
        const { source, commonDataEvents, events, isWidget } = this.props;
        const isMobile = getIsMobileWrapperFlag();
        const instructionContent = isMobile ? <Trans>{INSTRUCTION_CONTENT_MOBILE}</Trans> : <Trans>{INSTRUCTION_CONTENT_WEB}</Trans>;
        const instructionFooter = <Trans>{INSTRUCTION_FOOTER_TEXT}</Trans>;
        const instructionCards = getInstructionCards();
        const displayInstructionCard = this.props.isLoggedIn &&
            (instructionCards.indexOf(SPECIALS_INSTRUCTION_CARD) >= ZERO)
            && !this.state.instructionCardDismiss;
        const instructionCardProps = {
            contentText: instructionContent,
            footerText: instructionFooter,
            type: SPECIALS_INSTRUCTION_CARD,
            swiper: this.state.swiperRef,
            gtmAttribute: `${isWidget ? `${GTM_MAIN_COMPONENT};` : ''}${GTM_SUB_COMPONENT};`,
            pageMode: !isWidget,
            setInstructionCardDismissed: this.setInstructionCardDismissed,
        };

        if (isEmpty(commonDataEvents) || isEmpty(events) || !showWidget(events, commonDataEvents)) {
            return (displayInstructionCard && !isWidget) ?
                <div className={SPECIALS_LIST}>
                    <InstructionCard
                        { ...instructionCardProps }
                    />
                </div> : null;
        }
        const carouselOptions = {
            autoplay: false,
            lazy: false,
            navigation: {
                prevEl: `.${SPECIALS__WIDGET_CAROUSEL_NAV_PREV}`,
                nextEl: `.${SPECIALS__WIDGET_CAROUSEL_NAV_NEXT}`,
            },
            slidesPerView: 'auto',
        };

        const title = i18n.t(SPECIALS_TITLE);
        // slugify shouldn't be used, this is an exception case for US release
        const translatedlink = slugifyUrlEntities(title);

        return (
            <div className={COMPONENT_CLASS}>
                {
                    isWidget ? <WidgetContainer
                        title={title}
                        titleIconClassName={SPECIALS_TITLE_ICON_CLASS_NAME}
                        source={source}
                        gtmAttribute={`${GTM_MAIN_COMPONENT};${GTM_SUB_COMPONENT};${GTM_ACTION_SEE_ALL}`}
                        titleLink={seoUrlSport(translatedlink, getSportIdBySlug(SPECIAL_SLUG))}
                        previousArrow={this.getSliderArrows(SPECIALS__WIDGET_CAROUSEL_NAV_PREV)}
                        nextArrow={this.getSliderArrows(SPECIALS__WIDGET_CAROUSEL_NAV_NEXT)}
                    >
                        <Carousel
                            ref={(ref) => {this.swiper=ref; }}
                            options={carouselOptions}
                            customNav={true}
                            isMobile={isMobile}
                            gtmAttribute={`${GTM_MAIN_COMPONENT};${GTM_SUB_COMPONENT};${GTM_ACTION_SWIPE}`}
                            dismissGtmAttribute={`${GTM_MAIN_COMPONENT};${GTM_SUB_COMPONENT};${SPECIALS_SWIPER_DISMISS_GTM}`}
                            instructionCardType={SPECIALS_INSTRUCTION_CARD}
                            passSwiperRef={this.passSwiperRef}
                            onSwipe={this.setInstructionCardDismissed}
                        >
                            {
                                displayInstructionCard ? <InstructionCard
                                    { ...instructionCardProps }
                                /> : null
                            }
                            {this.createEventsListSection(this.props.events)}
                        </Carousel>
                    </WidgetContainer> :
                    <div className={SPECIALS_LIST}>
                        {
                            displayInstructionCard ? <InstructionCard
                                {...instructionCardProps}
                            /> : null
                        }
                        {this.createEventsListSection(this.props.events)}
                    </div>
                }
            </div>
        );
    }
}

export default flow(
    withLazyLoadContext(),
    connect(mapStateToProps, mapDispatchToProps),
)(SpecialsWidgetContainer);
